<template>
  <div
    class="d-flex pa-2 flex-row flex-wrap"
    :style="{ height: 'fit-content' }"
  >
    <card-row :title="'Search'" :cardColor="'white'" :displayed="true">
      <div style="width: 100%">
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              id="merchants"
              ref="merchants"
              :search-input.sync="searchMerchant"
              v-model="searchData.mid"
              :items="merchantList"
              hide-selected
              label="MID"
              persistent-hint
              item-value="mid"
              item-text="mid"
              :loading="loadingMerchant"
              hint="Search by MID"
              clearable
              dense
            >
              <template v-slot:item="{ item }">
                {{ item.mid + ' - ' + item.merchant_name }}
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="d-flex align-center justify-left">
          <v-col cols="12">
            <v-btn @click="clearSearch"> Reset </v-btn>
            <v-btn
              color="primary"
              class="ml-2"
              @click.stop="getData"
              :loading="loading"
              >show</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </card-row>
  </div>
</template>

<script>
import { getDate, date } from '../../lib/helpers';

export default {
  components: { CardRow: () => import('../CardRow.vue') },
  props: ['search', 'loading'],
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    loadingMerchant: false,
    searchMerchant: '',
    mId: null,
  }),
  mounted() {
    if (this.$route.query?.mid != '') {
      this.mId = this.$route.query.mid;
      this.getMerchant();
    }
  },
  watch: {
    searchMerchant(val) {
      if (val && val.length >= 3) {
        this.mId = val;
        this.getMerchant();
      } else {
        this.mId = '';
        this.$store.commit('report/clearMerchant');
      }
    },
  },
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    merchantList() {
      return this.$store.state.report.merchantList;
    },
    checkQueryNotSame() {
      return JSON.stringify(this.$route.query) !== JSON.stringify(this.search);
    },
  },
  methods: {
    getMerchant() {
      this.loadingMerchant = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      this.$store
        .dispatch('report/getMerchant', {
          date,
          sortBy: 'ID',
          search: { mid: this.mId },
          source: 'merchant',
        })
        .then(() => {
          this.loadingMerchant = false;
        });
    },
    clearSearch() {
      this.$emit('clearSearchParent');
    },
    getData() {
      if (this.checkQueryNotSame) {
        this.$router.push({ query: this.search });
      }

      this.$emit('getDataParent');
    },
    getDate,
  },
};
</script>
